import { useCallback, useEffect, useRef, useState } from 'react'
import { Field, FieldInputProps } from './types'

type UseSwappableFieldParams = {
  setIsEditing: FieldInputProps<Field>['setIsEditing']
}

/**
 * This hook enables focus to be maintained when a field's child components
 * are swapped based on the editing state.
 */
export const useSwappableField = ({
  setIsEditing,
}: UseSwappableFieldParams) => {
  const [displayRef, setDisplayRef] = useState<HTMLElement | null>(null)
  const shouldFocusDisplay = useRef(false)

  useEffect(() => {
    if (displayRef != null && shouldFocusDisplay.current) {
      setTimeout(() => displayRef.focus(), 0)
      shouldFocusDisplay.current = false
    }
  }, [displayRef])

  const onStopEditing = useCallback(() => {
    shouldFocusDisplay.current = true
    setIsEditing(false)
  }, [setIsEditing])

  return { setDisplayRef, onStopEditing }
}
